import { EditingLayer } from "fond/types";

import { NetworkTopologyConfig } from "../topologyHelper";

import { makeOnAfterDragUnderground } from "./onAfterDragUnderground";
import { makeOnCreateUndergroundPath } from "./onCreateUndergroundPath";
import { makeOnCreateUndergroundPoint } from "./onCreateUndergroundPoint";
import { makeOnSplitUndergroundPath } from "./onSplitUndergroundPath";
import { makeOnTrashUnderground } from "./onTrashUnderground";

type UndergroundEditCallbacks = {
  point: Pick<Required<EditingLayer>, "onCreate" | "onAfterDrag" | "onTrash">;
  path: Pick<Required<EditingLayer>, "onCreate" | "onSplit" | "onAfterDrag" | "onTrash">;
};

/**
 * EditingLayer callbacks for an underground path layer and its point layer.
 */
export const makeUndergroundEditCallbacks = (config: NetworkTopologyConfig): UndergroundEditCallbacks => {
  const onAfterDrag = makeOnAfterDragUnderground(config);
  const onTrash = makeOnTrashUnderground(config);

  return {
    point: { onCreate: makeOnCreateUndergroundPoint(config), onAfterDrag, onTrash },
    path: { onCreate: makeOnCreateUndergroundPath(config), onSplit: makeOnSplitUndergroundPath(config), onAfterDrag, onTrash },
  };
};
